import React from "react";
import ReactCountryFlag from "react-country-flag";
import { useTranslate } from "./TranslateContext";
import { Select, MenuItem, FormControl, Box } from "@mui/material";

const LanguagePicker = () => {
    const { language, setLanguage, translate } = useTranslate();

    const languages = [
        { code: "en", label: translate("english"), countryCode: "GB" },
        { code: "cs", label: translate("czech"), countryCode: "CZ" },
        { code: "fr", label: translate("french"), countryCode: "FR" },
        { code: "de", label: translate("german"), countryCode: "DE" },
        { code: "es", label: translate("spanish"), countryCode: "MX" },
        { code: "pt", label: translate("portuguese"), countryCode: "BR" },
        { code: "it", label: translate("italian"), countryCode: "IT" },
        { code: "pl", label: translate("polish"), countryCode: "PL" },
    ].sort((a, b) => a.label.localeCompare(b.label));

    const selected = languages.find((lang) => lang.code === language);

    const renderLanguage = (lang, inverse = false) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, color: inverse ? "var(--color-text-inverse)" : "text.primary" }}>
            <ReactCountryFlag countryCode={lang.countryCode} svg style={{ width: "1.4em", height: "1.4em", borderRadius: "3px" }} title={lang.label} />
            <Box component="span" sx={{ color: inverse ? "var(--color-text-inverse)" : "text.primary" }}>{lang.label}</Box>
        </Box>
    );

    return (
        <FormControl variant="outlined" size="small">
            <Select
                value={language}
                onChange={(e) => setLanguage(e.target.value)}
                displayEmpty
                renderValue={() => selected ? renderLanguage(selected, true) : ""}
                sx={{
                    bgcolor: "primary.main",
                    borderRadius: 1,
                    minWidth: 160,
                    "& .MuiSelect-icon": { color: "var(--color-text-inverse)" },
                    "& .MuiOutlinedInput-notchedOutline": { borderColor: "transparent" },
                    "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "transparent" },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "transparent" },
                }}
                MenuProps={{ PaperProps: { sx: { mt: 1 } } }}
            >
                {languages.map((lang) => (
                    <MenuItem key={lang.code} value={lang.code}>
                        {renderLanguage(lang)}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default LanguagePicker;